import { render, staticRenderFns } from "./ContactNote.vue?vue&type=template&id=d21ed3be&scoped=true"
import script from "./ContactNote.vue?vue&type=script&lang=js"
export * from "./ContactNote.vue?vue&type=script&lang=js"
import style0 from "./ContactNote.vue?vue&type=style&index=0&id=d21ed3be&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21ed3be",
  null
  
)

export default component.exports